import * as React from "react";
import { withRouter } from "react-router-dom";
import {  inject, observer } from "mobx-react";
import { AppProps } from "../../stores/storeContract";
import { View } from "../../stores/commonStore";
import "./Header.scss";

@inject("userStore", "commonStore", "notificationStore", "symbolStore")
@(withRouter as any)
@observer
export default class Header extends React.Component<AppProps> {

	render() {
			
		const { userName, isAdmin, logout } = this.props.userStore;
		const { soundMuted } = this.props.notificationStore;
		const { darkTheme, storeTheme, isMobile } = this.props.commonStore;
		const { isSymbolSyncNeeded } = this.props.symbolStore;

		var soundMutedTooltip = soundMuted ? 'Unmute' : 'Mute';
		var soundMutedText = soundMuted ? 'Unmute' : 'Mute';
        var soundMutedClass = soundMuted ? 'fas fa-volume-up' : 'fas fa-volume-mute';

		var themeTooltip = darkTheme ? 'Light theme' : 'Dark theme';
		//var themeText = darkTheme ? 'Light' : 'Dark';
        var themeClass = darkTheme ? 'fas fa-sun' : 'fas fa-moon';

		var settingsClass = isSymbolSyncNeeded && isAdmin ? 'btn btn-outline-danger btn-sm header-btn' : 'btn btn-outline-light btn-sm header-btn';
			
		return (
			<nav className="navbar header-navbar">
				<a className="header-logo" href="#" onClick={() => this.props.commonStore.view = View.Scanner}>M🌘onFinex Scanner</a>
				<a className="header-logo-mobile" href="#" onClick={() => this.props.commonStore.view = View.Scanner}>🌘</a>
				<div>
					<span className="header-label">{userName}</span>
					<button className={isMobile ? 'hidden' : settingsClass} title="Settings" onClick={() => this.props.commonStore.view = View.Settings}>
						<i className="fas fa-cogs"></i>
					</button>
					<button className="btn btn-outline-light btn-sm header-btn" title={themeTooltip} onClick={() => { this.props.commonStore.darkTheme = !this.props.commonStore.darkTheme; storeTheme(this.props.commonStore.darkTheme); }}>
						<i className={themeClass}></i>
					</button>
					<button className="btn btn-outline-light btn-sm header-btn" title={soundMutedTooltip} onClick={() => { this.props.notificationStore.soundMuted = !soundMuted; this.props.notificationStore.dismissSoundMutedToast(); } }>
						<i className={soundMutedClass}></i> {soundMutedText}
					</button>
					<button className="btn btn-outline-light btn-sm header-btn" title="Logout" onClick={logout}>
						<i className="fas fa-user"></i> Logout
					</button>
				</div>
			</nav>
		);
	}
}